//   待发货
export const awaitingDispatch = () => {
  return [
    {
      field: 'contractNo',
      title: '合同编号',
      visible: true,
    },
    {
      field: 'contractName',
      title: '合同名称',
      visible: true,
    },
    {
      field: 'supplierName',
      title: '供应商名称',
      visible: true,
    },
    {
      field: 'contractStatus',
      title: '合同状态',
      visible: true,
    },
  ];
};
// 待应收结算
export const pendingReceiptSettlement = () => {
  return [
    {
      field: 'contractNo',
      title: '合同编号',
      visible: true,
    },
    {
      field: 'contractName',
      title: '合同名称',
      visible: true,
    },
    {
      field: 'customerName',
      title: '客户名称',
      visible: true,
    },
    {
      field: 'expenseNo',
      title: '费用编号',
      visible: true,
    },
    {
      field: 'processStatus',
      title: '状态',
      visible: true,
    },
  ];
};
// 待应付结算
export const pendingPayableSettlement = () => {
  return [
    {
      field: 'contractNo',
      title: '合同编号',
      visible: true,
    },
    {
      field: 'contractName',
      title: '合同名称',
      visible: true,
    },
    {
      field: 'supplierName',
      title: '供应商名称',
      visible: true,
    },
    {
      field: 'expenseNo',
      title: '费用编号',
      visible: true,
    },
    {
      field: 'processStatus',
      title: '状态',
      visible: true,
    },
  ];
};
// 待收进项发票
export const pendingCollectInvoice = () => {
  return [
    {
      field: 'contractNo',
      title: '合同编号',
      visible: true,
    },
    {
      field: 'contractName',
      title: '合同名称',
      visible: true,
    },
    {
      field: 'supplierName',
      title: '供应商名称',
      visible: true,
    },
    {
      field: 'payableSettlementNo',
      title: '结算单编号',
      visible: true,
    },
    {
      field: 'settlementType',
      title: '结算类型',
      visible: true,
    },
    {
      field: 'settlementStatus',
      title: '单据状态',
      visible: true,
    },
  ];
};
// 待开票
export const pendingInvoice = () => {
  return [
    {
      field: 'contractNo',
      title: '合同编号',
      visible: true,
    },
    {
      field: 'contractName',
      title: '合同名称',
      visible: true,
    },
    {
      field: 'customerName',
      title: '客户名称',
      visible: true,
    },
    {
      field: 'receivableSettlementNo',
      title: '结算单编号',
      visible: true,
    },
    {
      field: 'settlementType',
      title: '结算类型',
      visible: true,
    },
    {
      field: 'settlementStatus',
      title: '单据状态',
      visible: true,
    },
    {
      field: 'settlementIssueStatus',
      title: '开票状态',
      visible: true,
    },
  ];
};
// 待付款
export const pendingPayment = () => {
  return [
    {
      field: 'contractNo',
      title: '合同编号',
      visible: true,
    },
    {
      field: 'contractName',
      title: '合同名称',
      visible: true,
    },
    {
      field: 'supplierName',
      title: '供应商名称',
      visible: true,
    },
    {
      field: 'payableSettlementNo',
      title: '结算单编号',
      visible: true,
    },
    {
      field: 'settlementType',
      title: '结算类型',
      visible: true,
    },
    {
      field: 'settlementStatus',
      title: '单据状态',
      visible: true,
    },
    {
      field: 'paymentStatus',
      title: '付款状态',
      visible: true,
    },
  ];
};
// 待收款
export const pendingReceiptPayment = () => {
  return [
    {
      field: 'contractNo',
      title: '合同编号',
      visible: true,
    },
    {
      field: 'contractName',
      title: '合同名称',
      visible: true,
    },
    {
      field: 'customerName',
      title: '客户名称',
      visible: true,
    },
    {
      field: 'receivableSettlementNo',
      title: '结算单编号',
      visible: true,
    },
    {
      field: 'settlementType',
      title: '结算类型',
      visible: true,
    },
    {
      field: 'settlementStatus',
      title: '单据状态',
      visible: true,
    },
    {
      field: 'firstInvoiceDate',
      title: '开票日期',
      visible: true,
    },
    {
      field: 'receiveStatus',
      title: '收款状态',
      visible: true,
    },
  ];
};
// 待提货
export const pendingPickup = () => {
  return [
    {
      field: 'contractNo',
      title: '合同编号',
      visible: true,
    },
    {
      field: 'supplierName',
      title: '供应商名称',
      visible: true,
    },
    {
      field: 'instructionNo',
      title: '供应商发货指令',
      visible: true,
    },
    {
      field: 'storageName',
      title: '仓库名称',
      visible: true,
    },
    {
      field: 'productName',
      title: '物料名称',
      visible: true,
    },
    {
      field: 'inboundDate',
      title: '入库时间',
      visible: true,
    },
    {
      field: 'storageQuantity',
      title: '库存数量',
      visible: true,
    },
    {
      field: 'productUnit',
      title: '单位',
      visible: true,
    },
  ];
};
